import React, { useState, useEffect } from "react";
import axios from "axios";

const DistributionExtend = ({ trans_date, year, month, district,office_id, fps_id,heading }) => {
  const [message, setMessage] = useState("");
  useEffect(() => {
    if (!trans_date || !year || !month || !district || !office_id || !fps_id ) {
      setMessage(" Missing data. Please go back and try again.");
      return;
    }

    const sendRequest = async () => {
      try {
        const payload = {
         
          dist_code: district,
          afso_code:office_id,
          fps_id: fps_id,
           version_year: year,
          version_month: month.toString().padStart(2, "0"),
           ver_date: trans_date 
         
        };

        const response = await axios.post(
          `${process.env.REACT_APP_URL}/api/distributionSucessful`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              'X-React-Route': window.location.href
            }
          }
        );
        setMessage(response.data.messsage );
      } catch (error) {
        setMessage(" Distribution Extension Failed (Server Error)");
      }
    };

    sendRequest();
  }, [trans_date, year, month, district]);

  return (
    <div className="p-6 text-center">
      {message ? (
        <div align="center" className="mainhead" >{message}</div>
      ) : (
        <div align="center" >Processing request...</div>
      )}
    </div>
  );
};

export default DistributionExtend;